import { useEffect, useState } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { getCampaigns } from '../api'

export const useGetCampaignsOnMount = () => {
  const dispatch = useAppDispatch()

  const [status, setStatus] = useState<'idle' | 'pending' | 'success' | 'fail'>(
    'idle',
  )

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      setStatus('pending')

      try {
        const result = await dispatch(getCampaigns())
        if (mounted) {
          if (getCampaigns.fulfilled.match(result)) {
            setStatus('success')
          } else {
            setStatus('fail')
          }
        }
      } catch {
        if (mounted) setStatus('fail')
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch])

  return status
}
